import './SocialLinks.css';

const INSTAGRAM_URL = 'https://www.instagram.com/kari_mash00?igsi=MThrZXN1MXdjYzNzcA==';
const YOUTUBE_URL = 'https://youtu.be/CbqyKUnm_Ek?si=WWURMJWhLZ4Vl7SP';

export default function SocialLinks({ className = '' }) {
  return (
    <div className={`social-links ${className}`}>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="social-link"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
          <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
        </svg>
        Follow me on Instagram
      </a>

      <a
        href={YOUTUBE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="social-link"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33 2.78 2.78 0 001.94 2c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.33 29 29 0 00-.46-5.33z" />
          <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
        </svg>
        Subscribe to my YouTube channel
      </a>
    </div>
  );
}
